import React from 'react';

import { Badge, Glyphicon, PositionedOverlay, Text } from 'reaxl';

import MediaGalleryImage from './MediaGalleryImage';

export default function SpinShowcase({
    src = '',
    alt = '',
    mediaType,
    hasFyusion,
    onClick = () => { },
}) {
    return (
        <PositionedOverlay id="spin360">
            <PositionedOverlay.Base>
                <MediaGalleryImage
                    alt={alt}
                    hasFyusion={hasFyusion}
                    lazyImage={false}
                    loading="eager"
                    mediaType={mediaType}
                    src={src}
                    type="main"
                    onClick={onClick}
                />
            </PositionedOverlay.Base>
            <PositionedOverlay.Anchor position="bottomCenter">
                <Badge
                    className="margin-bottom-4 padding-horizontal-3 padding-vertical-2 display-flex gap-2 media-360spin"
                >
                    <Glyphicon
                        glyph="degree-rotate"
                        className="text-size-400"
                    />
                    <Text size={300}> Take a Tour </Text>
                </Badge>
            </PositionedOverlay.Anchor>

        </PositionedOverlay>
    );
}
